// extracted by mini-css-extract-plugin
export default {"button_wrapper":"styles_button_wrapper__0SYho","tooltip":"styles_tooltip__ik1wS"};